import { render, staticRenderFns } from "./PhoneComponent.vue?vue&type=template&id=23ba5c33&scoped=true"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"
import style0 from "./PhoneComponent.vue?vue&type=style&index=0&id=23ba5c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba5c33",
  null
  
)

export default component.exports